// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container for the contact page form */
.contactForm_contactForm__RqnaE {
  position: relative;
  display: flex;
  justify-content: center;    /* center form horizontally */
  padding: 3rem 1rem;         /* vertical padding, narrow horizontal padding */
  /* background-image: url("../../../ASSETS/BACKGROUND/serviceBg.jpg"); */
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  color: #aab5b7;
  box-sizing: border-box;
}
/* 1. Remove any bottom padding/margin on the form container */
.contactForm_contactForm__RqnaE {
  padding-bottom: 0;       /* eliminate extra bottom space */
}

/* 2. Ensure the form section itself has no bottom margin */
.contactForm_contactFormFormSection__PiXjZ {
  margin-bottom: 0;
}

/* 3. Match the submit button width to the right-hand content width */
/* Assuming the right side uses max-width: 380px */
.contactForm_contactFormFormSection__PiXjZ {
  max-width: 380px;
  margin: 0 auto;
}

/* Make the submit full-width of that constrained form */
.contactForm_contactFormFormSubmit__oLPS\\+ {
  width: 100% !important;
  max-width: none;
  padding: 0.75em 0;
}

/* 4. If there’s a bottom spacer element, hide it */
.contactForm_contactPageSpacer__1Yg1D,  
.contactForm_faqPageSpacer__xntXD {     /* if any generic spacer */
  display: none !important;
}

/* 5. Responsive check */
@media (max-width: 768px) {
  .contactForm_contactFormFormSection__PiXjZ {
    max-width: 100%;
    padding-bottom: 0;
  }
  .contactForm_contactFormFormSubmit__oLPS\\+ {
    padding: 0.6em 0;
  }
}


/* Overlay spinner */
.contactForm_overlay__e0iKD {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background-color: rgba(17, 17, 17, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  border-radius: 1em;
}

/* Form wrapper: constrains width and centers */
.contactForm_contactFormFormSection__PiXjZ {
  width: 100%;
  max-width: 420px;           /* narrower max width */
  display: flex;
  flex-direction: column;
  gap: 1rem;                  /* consistent vertical spacing */
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Labels */
.contactForm_label__gpT8B {
  margin: 0 0 0.25rem;
  color: #ffffff;
  font-size: 0.9rem;
}

/* Input, select, textarea */
.contactForm_contactFormFormControl__ITDY8,
.contactForm_contactFormFormSelect__cjHq5,
textarea {
  width: 100%;
  border-radius: 1.5em;
  border: 1px solid rgba(255, 255, 255, 0.5);
  padding: 0.75em 1em;
  background-color: rgba(255, 255, 255, 0.9);
  font-size: 0.95rem;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
}

/* Placeholder styling */
.contactForm_contactFormFormControl__ITDY8::placeholder {
  color: rgba(0, 0, 0, 0.5);
}

/* Focus state */
.contactForm_contactFormFormControl__ITDY8:focus,
.contactForm_contactFormFormSelect__cjHq5:focus {
  outline: none;
  border-color: #aab5b7;
}

/* Error message */
.contactForm_contactFormTextDanger__LVT8R {
  color: #ff6b6b !important;
  font-size: 0.85rem;
}

/* Submit button */
.contactForm_contactFormFormSubmit__oLPS\\+ {
  align-self: center;         /* center under inputs */
  padding: 0.75em 2em;
  background-color: #ffffff !important;
  color: #111 !important;
  border: none !important;
  border-radius: 2em !important;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.contactForm_contactFormFormSubmit__oLPS\\+:hover {
  background-color: #dcd5d5 !important;
  transform: translateY(-1px);
}

/* Toast positioning */
.contactForm_toastCustom__IajrX {
  position: fixed;
  bottom: 1rem;
  right: 1rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .contactForm_contactForm__RqnaE {
    padding: 2rem 0.5rem;
  }
  .contactForm_contactFormFormSection__PiXjZ {
    max-width: 100%;
    gap: 0.75rem;
  }
  .contactForm_contactFormFormControl__ITDY8,
  .contactForm_contactFormFormSelect__cjHq5,
  textarea {
    font-size: 0.9rem;
    padding: 0.6em 0.8em;
  }
  .contactForm_contactFormFormSubmit__oLPS\\+ {
    padding: 0.6em 1.5em;
    font-size: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/COMPONENTS/FORM/CONTACT/contactForm.module.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB,KAAK,6BAA6B;EACzD,kBAAkB,UAAU,gDAAgD;EAC5E,uEAAuE;EACvE,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,cAAc;EACd,sBAAsB;AACxB;AACA,8DAA8D;AAC9D;EACE,iBAAiB,QAAQ,iCAAiC;AAC5D;;AAEA,2DAA2D;AAC3D;EACE,gBAAgB;AAClB;;AAEA,qEAAqE;AACrE,kDAAkD;AAClD;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,wDAAwD;AACxD;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA,mDAAmD;AACnD;wCACqB,0BAA0B;EAC7C,wBAAwB;AAC1B;;AAEA,wBAAwB;AACxB;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;AACF;;;AAGA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO;EACf,WAAW,EAAE,YAAY;EACzB,uCAAuC;EACvC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,gBAAgB,YAAY,uBAAuB;EACnD,aAAa;EACb,sBAAsB;EACtB,SAAS,mBAAmB,gCAAgC;EAC5D,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;;;EAGE,WAAW;EACX,oBAAoB;EACpB,0CAA0C;EAC1C,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB,UAAU,wBAAwB;EACpD,mBAAmB;EACnB,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;;;IAGE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;AACF","sourcesContent":["/* Container for the contact page form */\n.contactForm {\n  position: relative;\n  display: flex;\n  justify-content: center;    /* center form horizontally */\n  padding: 3rem 1rem;         /* vertical padding, narrow horizontal padding */\n  /* background-image: url(\"../../../ASSETS/BACKGROUND/serviceBg.jpg\"); */\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n  color: #aab5b7;\n  box-sizing: border-box;\n}\n/* 1. Remove any bottom padding/margin on the form container */\n.contactForm {\n  padding-bottom: 0;       /* eliminate extra bottom space */\n}\n\n/* 2. Ensure the form section itself has no bottom margin */\n.contactFormFormSection {\n  margin-bottom: 0;\n}\n\n/* 3. Match the submit button width to the right-hand content width */\n/* Assuming the right side uses max-width: 380px */\n.contactFormFormSection {\n  max-width: 380px;\n  margin: 0 auto;\n}\n\n/* Make the submit full-width of that constrained form */\n.contactFormFormSubmit {\n  width: 100% !important;\n  max-width: none;\n  padding: 0.75em 0;\n}\n\n/* 4. If there’s a bottom spacer element, hide it */\n.contactPageSpacer,  /* example class */\n.faqPageSpacer {     /* if any generic spacer */\n  display: none !important;\n}\n\n/* 5. Responsive check */\n@media (max-width: 768px) {\n  .contactFormFormSection {\n    max-width: 100%;\n    padding-bottom: 0;\n  }\n  .contactFormFormSubmit {\n    padding: 0.6em 0;\n  }\n}\n\n\n/* Overlay spinner */\n.overlay {\n  position: absolute;\n  top: 0; left: 0;\n  width: 100%; height: 100%;\n  background-color: rgba(17, 17, 17, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10;\n  border-radius: 1em;\n}\n\n/* Form wrapper: constrains width and centers */\n.contactFormFormSection {\n  width: 100%;\n  max-width: 420px;           /* narrower max width */\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;                  /* consistent vertical spacing */\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* Labels */\n.label {\n  margin: 0 0 0.25rem;\n  color: #ffffff;\n  font-size: 0.9rem;\n}\n\n/* Input, select, textarea */\n.contactFormFormControl,\n.contactFormFormSelect,\ntextarea {\n  width: 100%;\n  border-radius: 1.5em;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  padding: 0.75em 1em;\n  background-color: rgba(255, 255, 255, 0.9);\n  font-size: 0.95rem;\n  box-sizing: border-box;\n  transition: border-color 0.3s ease;\n}\n\n/* Placeholder styling */\n.contactFormFormControl::placeholder {\n  color: rgba(0, 0, 0, 0.5);\n}\n\n/* Focus state */\n.contactFormFormControl:focus,\n.contactFormFormSelect:focus {\n  outline: none;\n  border-color: #aab5b7;\n}\n\n/* Error message */\n.contactFormTextDanger {\n  color: #ff6b6b !important;\n  font-size: 0.85rem;\n}\n\n/* Submit button */\n.contactFormFormSubmit {\n  align-self: center;         /* center under inputs */\n  padding: 0.75em 2em;\n  background-color: #ffffff !important;\n  color: #111 !important;\n  border: none !important;\n  border-radius: 2em !important;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n}\n\n.contactFormFormSubmit:hover {\n  background-color: #dcd5d5 !important;\n  transform: translateY(-1px);\n}\n\n/* Toast positioning */\n.toastCustom {\n  position: fixed;\n  bottom: 1rem;\n  right: 1rem;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .contactForm {\n    padding: 2rem 0.5rem;\n  }\n  .contactFormFormSection {\n    max-width: 100%;\n    gap: 0.75rem;\n  }\n  .contactFormFormControl,\n  .contactFormFormSelect,\n  textarea {\n    font-size: 0.9rem;\n    padding: 0.6em 0.8em;\n  }\n  .contactFormFormSubmit {\n    padding: 0.6em 1.5em;\n    font-size: 0.9rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contactForm": `contactForm_contactForm__RqnaE`,
	"contactFormFormSection": `contactForm_contactFormFormSection__PiXjZ`,
	"contactFormFormSubmit": `contactForm_contactFormFormSubmit__oLPS+`,
	"contactPageSpacer": `contactForm_contactPageSpacer__1Yg1D`,
	"faqPageSpacer": `contactForm_faqPageSpacer__xntXD`,
	"overlay": `contactForm_overlay__e0iKD`,
	"label": `contactForm_label__gpT8B`,
	"contactFormFormControl": `contactForm_contactFormFormControl__ITDY8`,
	"contactFormFormSelect": `contactForm_contactFormFormSelect__cjHq5`,
	"contactFormTextDanger": `contactForm_contactFormTextDanger__LVT8R`,
	"toastCustom": `contactForm_toastCustom__IajrX`
};
export default ___CSS_LOADER_EXPORT___;
